export default __webpack_public_path__ + "static/media/IMG9194.384b54da.jpg";